import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Router } from '@angular/router';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'


//constants
import { Constants } from '../../constants/Constants';

//components
import { BaseRequestComponent } from '../../baseclasses/BaseRequest.component';
import { UserInfoComponent } from '../../components/ControlGroups/UserInfo.component';
import { CompletionDetailsComponent } from '../../components/ControlGroups/CompletionDetails.component';
import { RequestHeaderComponent } from '../../components/Controls/RequestHeader.component';
import { ChangePhoneNumberDialogComponent } from '../../components/Employees/ChangePhoneNumberDialog.component';
import { PayerLinkageDetailsComponent } from '../ControlGroups/PayerLinkageDetails.component';
import { NotesComponent } from '../../components/ControlGroups/Notes.component';

// export const BASE_REQUEST_ACCESSOR: any = {
//     provide: NG_VALUE_ACCESSOR,
//     useExisting: forwardRef(() => CreateDriverRequestComponent),
//     multi: true
// };

@Component({
    selector: 'my-create-payer-linkages-request',
    templateUrl: './CreatePayerLinkagesRequest.component.html',
    providers: [{ provide: BaseRequestComponent, useExisting: forwardRef(() => CreatePayerLinkagesRequestComponent) }]
})
export class CreatePayerLinkagesRequestComponent extends BaseRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;
    @ViewChild(PayerLinkageDetailsComponent) payerLinkageDetailsComponent: PayerLinkageDetailsComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;

    constructor() {
        super();
    }


    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus()) {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();


    }

    getUpdateNeededValue(): number {
        return enums.UpdateNeededEnum.Update;
    }

    onSaveClick(event: any) {

        this.requestToSave = {
            ID: this.requestID,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            PayerLinkageInfo: this.payerLinkageDetailsComponent.payerLinkageInfo,
            OtherInfo: this.notesComponent.otherInfo,
            RequestTypeID: enums.RequestTypeEnum.PayerLinkages,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID,
            SalesOfficeID: this.userInfoComponent.userInfo.SalesOffice.ID,
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);

        //this.requestToSave.PayerLinkageInfo.CustomerNumbers = this.payerLinkageDetailsComponent.getCustomerNumbers();
        this.requestToSave.PayerLinkageCustomers = this.payerLinkageDetailsComponent.getPayerLinkageCustomers();

        if (this.userInfoComponent.request.PhoneNumber) {
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }


        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);

    }
    onYes(event: ent.Response) {
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any) {
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any) {
        //do nothing
    }

}
